import React from 'react';

import Conversations from '../Conversations';

const ChatPanel = () => <Conversations />;

export default React.memo(ChatPanel);
